<style scoped>
	.dtitems-wrapper {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		background-color: #eee;
		z-index: 100;
		/* overflow: scroll; */
		font-size: .8em;
		color: #656565;
	}
	.dtitems-div {
		height: 85%;
	}
	.dt-item-p{
		margin: .3em 1em;
	}
	.dtitems-th {
		margin: 10px 10px 1px 10px;
	}
	.dtitems-td {
		margin: 0px 10px 0px 10px;
	}
	.dtitems-td-col {
		display: inline-block;
		margin: 10px 5px 2px 5px;
	}
	.dtitems-th-col {
		display: inline-block;
		margin: 10px 10px 2px 6px;
	}
	.dtitems-th-col-name {
		width: 90px;
	}
	.dtitems-th-col-unit {
		width: 30px;
	}
	.dtitems-content {
		overflow: scroll;
		height: 95%;
		background-color: #fcfcfc;
	}
	.dtitems-div-bottom {
		height: 30px;
	}
	.dtitems-bottom-btn {
		margin: 6px 0 0 0;
		width: 80px;
		background-color: #dedede;
		color: #787878;
		display: block;
		border: solid #aaa 1px;
		border-radius: 3px;
		float: right;
	}
	.dtitems-th-col-name {
		width: 80px;
	}
	.dtitems-th-col-amount {
		width: 90px;
		text-align: right;
	}
	.dtitems-th-col-money {
		width: 80px;
		text-align: right;
	}
	.dtitems-td-col-amount {
		width: 90px;
		text-align: right;
		overflow: scroll;
		height: 16px;
		vertical-align: bottom;
	}
	.dtitems-td-col-money {
		width: 100px;
		text-align: right;
		overflow: scroll;
		height: 16px;
		vertical-align: bottom;
	}
</style>
<template>
	<div>
		<transition name="slide">
			<div v-show="show" class="dtitems-wrapper">
				<div class="dtitems-header">
					<navbar title="供货商对账单-明细-品项"></navbar>
					<w-search
						v-show="true"
						v-model="searchKey"
						placeholder="可搜索品项名称"
						:showFilterBtn="false"
					></w-search>
				</div>
				<div class="dtitems-div">
					<div class="dtitems-th">
						<div class="dtitems-th-col dtitems-th-col-name">品项名称</div>
						<div class="dtitems-th-col dtitems-th-col-amount">数量</div>
						<div class="dtitems-th-col dtitems-th-col-unit">单位</div>
						<div class="dtitems-th-col dtitems-th-col-money">含税金额</div>
					</div>
					<div class="dtitems-content">
						<div class="dtitems-td" v-for = "(item, index) in itemListCalc">
							<div class="dtitems-td-col dtitems-th-col-name">{{item.item_name}}</div>
							<div class="dtitems-td-col dtitems-td-col-amount">{{item.instore_sum_amount}}</div>
							<div class="dtitems-td-col dtitems-th-col-unit">{{item.unit}}</div>
							<div class="dtitems-td-col dtitems-td-col-money">{{item.include_tax_sum_money}}</div>
						</div>
					</div>
				</div>
				<div class="dtitems-div-bottom" @click="onDtitemClick">
					<button class="dtitems-bottom-btn">返回</button>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
import NavBar from '../components/NavBar'
export default {
	props: {
		restaurantId: String
	},
	data () {
		return {
			show: false,
			itemList: [],
			searchKey: ''
		}
	},
	components: {
		'navbar': NavBar
	},
	computed: {
		itemListCalc () {
			return this.itemList.filter(item => {
				return item.item_name.indexOf(this.searchKey) !== -1
			})
		}
	},
	methods: {
		open (itemList) {
			this.itemList = itemList
			this.show = !this.show
		},
		onDtitemClick () {
			this.show = !this.show
		},
		onSearchClick () {
			console.log('onSearchClick')
		}
	}
}
</script>



// WEBPACK FOOTER //
// SupplierAccountCheckDetailBillDt.vue?6df7e060